import {
  GenericField,
  WbCard,
  WbCardContent,
} from '@agilelab/plugin-wb-platform';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    width: '100%',
    gap: 50,
    flexWrap: 'wrap',
  },
}));

export const RolesDetailDrawer = (props: {
  role: string;
  subject: string;
  roleDescription: string;
  target: string;
}) => {
  const classes = useStyles();

  return (
    <WbCard title={props.role}>
      <WbCardContent>
        <Box className={classes.row}>
          <GenericField label="Subject" value={props.subject} type="string" />
          <GenericField
            label="Description"
            value={props.roleDescription}
            type="string"
          />
          <GenericField label="Target" value={props.target} type="string" />
        </Box>
      </WbCardContent>
    </WbCard>
  );
};
